import { t } from "i18next";
import { Input } from "libs/design-system/src/components/Input";
import TextArea from "libs/design-system/src/components/TextArea";
import styles from './iframeModal.module.scss';

export const IframeModal = ({ form, setForm }: any) => {
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setForm((prev: any) => ({ ...prev, [name]: value }));
  };

  return (
    <div className={styles['iframe-modal']}>

      <Input
        name="name"
        label={t('innerLayout.iFramesPage.duplicateModal.nameLabel')}
        placeholder={t('innerLayout.iFramesPage.duplicateModal.namePlaceholder')}
        value={form.name}
        onChange={handleChange}
      />

      <Input
        name="description"
        label={t('innerLayout.iFramesPage.duplicateModal.descriptionLabel')}
        placeholder={t('innerLayout.iFramesPage.duplicateModal.descPlaceholder')}
        value={form.description}
        onChange={handleChange}
      />

      <TextArea
        name="content_html"
        defaultValue={""}
        label="HTML"
        placeholder={t('innerLayout.iFramesPage.duplicateModal.htmlPlaceholder')}
        value={form.content_html}
        onChange={handleChange}
        maxLength={Infinity}
      />

      <TextArea
        name="content_css"
        defaultValue={""}
        label="CSS"
        placeholder={t('innerLayout.iFramesPage.duplicateModal.cssPlaceholder')}
        value={form.content_css}
        onChange={handleChange}
        maxLength={Infinity}
      />

      <TextArea
        name="content_js"
        label={"JavaScript"}
        defaultValue={""}
        placeholder={t('innerLayout.iFramesPage.duplicateModal.javascriptPlaceholder')}
        value={form.content_js}
        onChange={handleChange}
        maxLength={Infinity}
      />
    </div>
  );
};
